import { Environments, LTIPlatformDTO, ProviderSiteDTO, SSOProviderDTO } from "@beable/roster-backend-client-v1";

export const SUBPAGES: {[index: string]: any } = {
  providers: {
    value: 'providers',
    text: 'Providers',
    defaultState: {
      id: '',
      name: '',
      environment: Environments.qa,
      customerIdentifier: '',
      userIdentifier: '',
      userIdentifierAccessor: '',
      redirectUrl: ''
    } as SSOProviderDTO
  },
  providerSites: {
    value: 'providerSites',
    text: 'Sites',
    defaultState: {
      id: '',
      siteId: 0,
      providerId: '',
      identifier: '',
      active: true,
      siteName: '',
      providerValidation: 'N/A',
      providerValidationString: 'N/A'
    } as ProviderSiteDTO
  },
  LTIProviders: {
    value: 'LTIProviders',
    text: 'LTI Platforms',
    defaultState: {
      id: '',
      name: '',
      environment: Environments.qa,
      issuer: '',
      authRedirectUrl: '',
      userLookupField: '',
      logoutRedirectUrl: '',
      identifierTransforms: '',
      clientId: '',
      deploymentId: '',
      keyset: '',
      keysetUrl: '',
      siteId: 0,
      useStaticLaunch: false,
      active: true,
    } as LTIPlatformDTO
  }
};
